const axios = require("axios");
/* NodeJS */
const url = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;
const urlV5 = url.replace("v1", "v5");

module.exports = {
  getBooking: (
    accessToken,
    bookingNumber,
    language = "en",
    checkInDate = null
  ) =>
    axios({
      method: "GET",
      url: `${url}/bookings/${bookingNumber}?language=${language}${
        checkInDate ? `&check_in_date=${checkInDate}` : ""
      }`,
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
  getUpcomingBooking: (
    accessToken,
    checkInDate,
    bookingType,
    lastNameOrEmail = null,
    language = "en"
  ) => {
    const bookingInputName =
      bookingType === "GuestName" ? "last_name" : "email";
    return axios({
      method: "GET",
      url: `${url}/bookings/upcomingstays${
        checkInDate ? `?check_in_date=${checkInDate}&` : "?"
      }${bookingInputName}=${lastNameOrEmail}&language=${language}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
  postBooking: (accessToken, bookingNumber, guestData) =>
    axios({
      method: "PUT",
      url: `${url}/bookings/${bookingNumber}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "multipart/form-data",
      },
      data: guestData,
    }),
  getBookingStatus: (accessToken, bookingNumber, email) =>
    axios({
      method: "GET",
      url: `${url}/bookings/${bookingNumber}/status`,
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        email: email,
      },
    }),
  getHotelKeyBooking: ({
    accessToken,
    bookingNumber,
    lastName,
    language = "en",
    checkInDate = null,
  }) =>
    axios({
      method: "GET",
      url: `${url}/bookings/${bookingNumber}?language=${language}${
        lastName ? `&last_name=${lastName}` : ""
      }${checkInDate ? `&check_in_date=${checkInDate}` : ""}`,
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
  getHotelKeyBookingV5: (
    accessToken,
    bookingNumber,
    lastName,
    language = "en",
    checkInDate = null
  ) =>
    axios({
      method: "GET",
      url: `${urlV5}/bookings/${bookingNumber}?language=${language}&last_name=${lastName}${
        checkInDate ? `&check_in_date=${checkInDate}` : ""
      }`,
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
  getBookingStatusV5: (accessToken, bookingNumber, lastName, email) =>
    axios({
      method: "GET",
      url: `${urlV5}/bookings/${bookingNumber}/status`,
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        email: email,
        last_name: lastName,
      },
    }),
  putPreferences: (
    accessToken,
    propertyUid,
    profileId,
    preferences,
    language = "en"
  ) =>
    axios({
      method: "PUT",
      url: `${urlV5}/bookings/update_preferences?language=${language}&property_uid=${propertyUid}&access_token=${accessToken}`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: {
        profile_id: profileId,
        preferences,
      },
    }),
};
